export enum StorageItem {
  Session = 'Session',
  Lookups = 'Lookups',
  RefreshTokenMeta = 'RefreshTokenMeta',
  TablesMeta = 'TablesMeta'
}
